import React from 'react'

export default function DotsVerticalIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.5 6.00005C13.5 6.8285 12.8285 7.5001 12.0001 7.5001C11.1718 7.5001 10.5002 6.8285 10.5002 6.00005C10.5002 5.17159 11.1718 4.5 12.0001 4.5C12.8285 4.5 13.5 5.17159 13.5 6.00005Z" fill="currentColor"/>
            <path d="M13.4998 12.0012C13.4998 12.8297 12.8282 13.5013 11.9999 13.5013C11.1715 13.5013 10.5 12.8297 10.5 12.0012C10.5 11.1728 11.1715 10.5012 11.9999 10.5012C12.8282 10.5012 13.4998 11.1728 13.4998 12.0012Z" fill="currentColor"/>
            <path d="M13.4998 18C13.4998 18.8284 12.8282 19.5 11.9999 19.5C11.1715 19.5 10.5 18.8284 10.5 18C10.5 17.1715 11.1715 16.4999 11.9999 16.4999C12.8282 16.4999 13.4998 17.1715 13.4998 18Z" fill="currentColor"/>
        </svg>
    )
}
